export enum SignalRSendEvent {
    SubmitEmote,
    ShowLeaderboard,
}

export enum SignalRReceiveEvent {
    Emote,
    ShowLeaderboard,
}